/* eslint-disable */
import _ from 'underscore';
import filterSerializer from '@bingads-webui-campaign-legacy/bulk-operation/util/grid-filter-serializer';
import errorMapper from '@bingads-webui-static-legacy/api-error-mapper-service';
import pageContext from '@bingads-webui-static-legacy/page-context';
import decimalFormat from '@bingads-webui-component-legacy/humanize/decimal';
import campaignBudgetTypes from '@bingads-webui-static-legacy/schema/campaign/budgetTypes';
import * as safeJSON from '@bingads-webui/safe-json';
import urlOptionsFields from '@bingads-webui-static-legacy/bulk-edit/viewmodel/shared/urlOptionsFields';
import copyPasteDescriptions from '@bingads-webui-static-legacy/bulk-edit/viewmodel/shared/copyPasteDescriptions';
import escapeHelper from '@bingads-webui-static-legacy/bulk-edit/view/escapeHelper';
import deliveryStatus from '@bingads-webui-static-legacy/schema/account/deliveryStatus';
import * as hotelCenterUtils from '@bingads-webui-campaign-legacy/hotel-center-utils/index';
import * as RSAHelper from '@bingads-webui-campaign/summary-grid-helper';
import * as customColumnUtils from '@bingads-webui-universal/custom-column-utils';
import * as customColumnServiceWrapper from '@bingads-webui/custom-column-service-wrapper';
import * as customColumnPreference from '@bingads-webui-component-legacy/bingads-grid/service/custom-column-preferences';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
var bidUtils = hotelCenterUtils.bidUtils;
var bidMultiplierUtils = hotelCenterUtils.bidMultiplierUtils;
var metadata = {
  'AdScheduleUseSearcherTimeZone': {
    argFields: ['Value'],
    additionalArgs: []
  },
  'BidAmount/Bid/Amount': {
    argFields: ['Value'],
    additionalArgs: []
  },
  'BidBoost/Multiplier': {
    argFields: ['Value'],
    additionalArgs: [],
    formatEntityValueFunction: _formatBidMultipliersEntityValue
  },
  'IsExcluded': {
    argFields: ['Value'],
    additionalArgs: []
  },
  'CriterionBid/Bid/Amount': {
    argFields: ['Value'],
    additionalArgs: []
  },
  'Bid': {
    argFields: ['Value'],
    additionalArgs: [],
    formatEntityValueFunction: _formatBidEntityValue
  },
  'BidAdjustment': {
    argFields: ['Value'],
    additionalArgs: [],
    jobSelectionFunction: _bidAdjustmentJobSelectionFunction,
    summaryFunction: _bidAdjustmentSummaryFunction
  },
  'BidMultipliers': {
    argFields: ['Value'],
    additionalArgs: [],
    formatEntityValueFunction: _formatBidMultipliersEntityValue
  },
  'CampaignCashback/Percent': {
    argFields: ['Value'],
    summaryFunction: _getJobSummaryCashbackPercent
  },
  'AdGroupCashback/Percent': {
    argFields: ['Value'],
    summaryFunction: _getJobSummaryCashbackPercent
  },
  'CashbackAdjustment': {
    argFields: ['Value'],
    summaryFunction: _getJobSummaryCashbackPercent
  },
  'PercentCpcBid/RateAmount/Amount': {
    argFields: ['Value'],
    summaryFunction: _getJobSummaryPercentCpcBid,
    localizeAdditionalArgsFunction: _localizePercentAdditionalArgs
  },
  'CommissionRate/RateAmount/Amount': {
    argFields: ['Value'],
    summaryFunction: _getJobSummaryCommissionRate,
    localizeAdditionalArgsFunction: _localizePercentAdditionalArgs
  },
  'AudienceCriterion/CashbackAdjustment': {
    argFields: ['Value'],
    summaryFunction: _getJobSummaryCashbackPercent
  },
  'ProductGroupCashback/Percent': {
    argFields: ['Value'],
    summaryFunction: _getJobSummaryCashbackPercent
  },
  'CampaignCashback/MonthlyBudget': {
    argFields: ['Value'],
    summaryFunction: _getJobSummaryCampaignCashbackMonthlyBudget
  },
  'Bid/Amount': {
    argFields: ['Value'],
    additionalArgs: [],
    formatEntityValueFunction: _formatBidAmountEntityValue,
    localizeAdditionalArgsFunction: _localizeBidAmountAdditionalArgs
  },
  Status: {
    argFields: ['Value'],
    summaryFunction: _statusSummaryFunction
  },
  'Budget/Amount': {
    argFields: ['Value'],
    summaryFunction: _getJobSummaryCampaignBudget
  },
  'BiddingScheme': {
    argFields: ['Value'],
    formatEntityValueFunction: _formatBiddingSchemeEntityValue
  },
  'BidStrategyId': {
    argFields: ['Value'],
    formatEntityValueFunction: _formatBidStrategyIdEntityValue
  },
  'MatchType': {
    argFields: ['Value', 'SearchString']
  },
  'ContentBid': {
    argFields: ['Value']
  },
  'SearchBid': {
    argFields: ['Value']
  },
  'Title': {
    argFields: ['Value', 'SearchString']
  },
  'TitlePart2': {
    argFields: ['Value', 'SearchString']
  },
  'TitlePart3': {
    argFields: ['Value', 'SearchString']
  },
  'Text': {
    argFields: ['Value', 'SearchString']
  },
  'TextPart2': {
    argFields: ['Value', 'SearchString']
  },
  'BusinessName': {
    argFields: ['Value', 'SearchString']
  },
  'Headline': {
    argFields: ['Value', 'SearchString']
  },
  'Headlines': {
    argFields: ['Value', 'SearchString']
  },
  'Descriptions': {
    argFields: ['Value', 'SearchString']
  },
  'LongHeadline': {
    argFields: ['Value', 'SearchString']
  },
  'DisplayUrl': {
    argFields: ['Value', 'SearchString']
  },
  'DestinationUrl': {
    argFields: ['Value', 'SearchString']
  },
  'FinalUrls': {
    argFields: ['Value', 'SearchString']
  },
  'Path1': {
    argFields: ['Value', 'SearchString']
  },
  'Path2': {
    argFields: ['Value', 'SearchString']
  },
  'MobileFinalUrls': {
    argFields: ['Value', 'SearchString']
  },
  'DevicePreference': {
    argFields: ['Value', 'SearchString']
  },
  'TrackingUrlTemplate': {
    argFields: ['Value', 'SearchString']
  },
  'FinalUrlSuffix': {
    argFields: ['Value', 'SearchString']
  },
  'UrlCustomParameters': {
    argFields: ['Value', 'SearchString']
  },
  'UrlCustomParameters/Key': {
    argFields: ['Value', 'SearchString']
  },
  'UrlCustomParameters/Value': {
    argFields: ['Value', 'SearchString']
  },
  'AudienceCriterion/BidMultiplier': {
    argFields: ['Value']
  },
  'AdGroupAudienceAssociation': {
    argFields: ['AssociationList']
  },
  'AudienceAssociation': {
    argFields: ['AssociationList']
  },
  'CopyAction': {
    argFields: ['DestinationParentEntityIds'],
    summaryFunction: _getCopyPasteSummary,
    localizeAdditionalArgsFunction: _localizeCopyPasteArgs,
    jobSelectionFunction: _getCopyPasteSelection,
    formatEntityValueFunction: _formatCopyPasteEntityValue,
    historyJobDetails: 'CopyHistoryJobDetails'
  },
  'QueryOnlyAction': {
    argFields: ['Value']
  },
  'LabelAssociation': {
    argFields: ['AssociationList']
  },
  'LabelDisassociation': {
    argFields: ['AssociationList']
  },
  'Languages': {
    argFields: ['Value']
  },
  'Language': {
    argFields: ['Value']
  }
}, quickFilters = {
  enabledCampaigns: {
    SelectedColumn: 'CampaignStatus',
    SelectedOperator: 'EnumSelection',
    Values: ['121', '126']
  },
  enabledKeywords: {
    SelectedColumn: 'KeywordStatus',
    SelectedOperator: 'EnumSelection',
    Values: ['161']
  },
  enabledAdGroups: {
    SelectedColumn: 'AdGroupStatus',
    SelectedOperator: 'EnumSelection',
    Values: ['141', '126']
  },
  enabledAds: {
    SelectedColumn: 'AdUiDisplayStatus',
    SelectedOperator: 'EnumSelection',
    Values: ['1']
  }
}, dataSourceFilters = {
  criterionType: {
    SelectedColumn: 'Criterion',
    SelectedOperator: '$isof',
    Values: ['Model.AgeCriterion', 'Model.GenderCriterion', 'Model.CompanyNameCriterion', 'Model.JobFunctionCriterion', 'Model.IndustryCriterion']
  },
  LevelOfDetails: {
    SelectedColumn: 'LevelOfDetails',
    SelectedOperator: 'Equal',
    Values: ['AdGroup']
  }
};
var booleanFields = ['KeywordIsLastImported', 'CampaignIsLastImported', 'AdIsLastImported', 'AdGroupIsLastImported'];
function _getJobModelInfo(jobModel) {
  var batchAction = jobModel.get('BatchAction'), firstActionModel = batchAction.Actions[0], properties = _.pluck(batchAction.Actions, 'Property'), entity = jobModel.get('Entity'), actionValueType = _getActionValueType(firstActionModel), jobMetadata = metadata[properties[0]] || metadata[actionValueType] || ({}), isCashbackPercent = typeof properties[0] === 'string' ? properties[0].search('Cashback/Percent') !== -1 || properties[0].search('CashbackAdjustment') !== -1 : false, isCashbackBudget = properties[0] === 'CampaignCashback/MontlyBudget';
  var isPercentCPCBid = properties[0] === 'PercentCpcBid/RateAmount/Amount';
  var isCommissionRate = properties[0] === 'CommissionRate/RateAmount/Amount';
  return {
    properties: properties,
    entity: entity,
    metadata: jobMetadata,
    actionValueType: actionValueType,
    actions: batchAction.Actions,
    isNumeric: !!(actionValueType === 'NumericAction' || actionValueType === 'BidEstimateAction'),
    isCurrency: firstActionModel.ActionType === 'ChangeByAmount' || firstActionModel.ActionType === 'SetToAmount' && entity !== 'AdGroupAudienceAssociation' && entity !== 'AudienceAssociation' && entity !== 'CampaignCriterion' && entity !== 'AdGroupCriterion' || isCashbackBudget,
    isPercent: firstActionModel.ActionType === ('SetToAmount' && (entity === 'AdGroupAudienceAssociation' || entity === 'AudienceAssociation' || entity === 'CampaignCriterion' || entity === 'AdGroupCriterion')) || isCashbackPercent || isPercentCPCBid || isCommissionRate
  };
}
function _getActionValueType(actionModel) {
  var actionValueType = _.chain(actionModel).values().find(function (item) {
    return item.indexOf('#Model') === 0;
  }).value();
  return actionValueType ? actionValueType.substring(('#Model.').length) : 'TextAction';
}
function getJobDescription(jobModel) {
  var modelInfo = _getJobModelInfo(jobModel), summaryFunction = modelInfo.metadata.summaryFunction || _getJobSummary, localizeAdditionalArgsFunction = modelInfo.metadata.localizeAdditionalArgsFunction || _localizeAdditionalArgs;
  return {
    summary: summaryFunction(jobModel, modelInfo),
    args: localizeAdditionalArgsFunction(modelInfo)
  };
}
function splitProperty(property) {
  var splitStr = property.replace(/([A-Z])/g, ' $1').toLowerCase().trim();
  return splitStr.charAt(0).toUpperCase() + splitStr.slice(1);
}
function _getJobSummary(jobModel, modelInfo) {
  var entityName = i18n.getString('EntityName_' + modelInfo.entity), jobSummary = '';
  _.each(modelInfo.actions, function (item, index) {
    var singleLineSummary = '';
    var property = modelInfo.properties[index];
    var propertyMsg = splitProperty(property || '');
    var propertyName = i18n.getString('Property_' + property) || propertyMsg;
    var i18nActionBasedKey = _geti18nActionBasedKey(modelInfo, index);
    var i18nValueBasedKey = _geti18nValueBasedKey(modelInfo, index);
    if (property === urlOptionsFields.customParameters && _.isArray(item.Value)) {
      var value = _.map(item.Value, function (param, index) {
        var val = safeJSON.parseSync(param) || ({});
        return '{_' + val.Key + '} =' + val.Value;
      });
      var localizedKey = i18nActionBasedKey;
      var actionType;
      if (item.ActionType != modelInfo.actions[0].ActionType) {
        localizedKey = 'History_Description_' + modelInfo.actionValueType + '_' + item.ActionType;
      }
      var summary = i18n.getString(localizedKey, entityName, propertyName, value);
      singleLineSummary += summary;
    } else {
      var jobArgs = _getJobArguments(modelInfo, item);
      var args = jobArgs.length ? jobArgs : [item.Value || ''];
      if (!modelInfo.isNumeric && !modelInfo.isCurrency) {
        _.each(args, function (item, index, list) {
          var localizedString = i18n.getString('History_Description_' + item);
          if (localizedString) {
            list[index] = localizedString;
          }
          ;
        });
      }
      var i18nActionBasedArgs = [i18nActionBasedKey, entityName, propertyName].concat(args);
      var i18nValueBasedArgs = [i18nValueBasedKey, entityName, propertyName].concat(args);
      var valueBased = i18n.getString.apply(i18n, i18nValueBasedArgs);
      var actionBased = i18n.getString.apply(i18n, i18nActionBasedArgs);
      singleLineSummary += valueBased || actionBased;
    }
    singleLineSummary = escapeHelper.escape(singleLineSummary);
    jobSummary = index > 0 ? jobSummary.concat('<br/>') : jobSummary;
    jobSummary = jobSummary.concat(singleLineSummary);
  });
  return jobSummary;
}
function _geti18nValueBasedKey(jobInfo, index) {
  index = index <= 0 ? 0 : index;
  return 'History_Description_' + jobInfo.properties[index] + '_' + jobInfo.entity + '_' + jobInfo.actions[index].Value;
}
;
function _geti18nActionBasedKey(jobInfo, index) {
  index = index <= 0 ? 0 : index;
  var key = 'History_Description_' + jobInfo.actionValueType + '_' + jobInfo.actions[index].ActionType;
  if (jobInfo.isNumeric && jobInfo.actions[index].Value && jobInfo.actions[index].ActionType !== 'SetToAmount') {
    key = key + (jobInfo.actions[index].Value > 0 ? '_Increase' : '_Decrease');
  }
  if (jobInfo.entity === 'Keyword' && jobInfo.properties[index] === 'MatchType') {
    key = 'History_Description_Keyword_MatchType';
  }
  if (jobInfo.entity === 'AdGroup' && jobInfo.properties[index] === 'AdGroupAudienceAssociation') {
    var isNewAudienceEnabled = pageContext.Permissions.IsNewAudienceEnabled;
    key = 'History_Description_AudienceAssociationAction' + '_' + jobInfo.actions[index].BidType + (isNewAudienceEnabled ? '_CustomInMarket' : '');
  } else if ((jobInfo.entity === 'AdGroup' || jobInfo.entity === 'Campaign') && jobInfo.properties[index] === 'AudienceAssociation') {
    key = 'History_Description_AudienceAssociationAction_Campaign_' + jobInfo.actions[index].BidType;
  } else if (jobInfo.properties[index] === 'LabelAssociation' || jobInfo.properties[index] === 'LabelDisassociation') {
    var isSingular = jobInfo.actions[index].AssociationList && jobInfo.actions[index].AssociationList.length <= 1;
    key = 'History_Description_' + jobInfo.properties[index] + '_' + jobInfo.entity;
    if (isSingular) {
      key += '_Singular';
    }
  }
  if (_.contains(['Hotel', 'HotelGroup'], jobInfo.entity)) {
    if (jobInfo.properties[index] === 'Bid' || jobInfo.properties[index] === 'BidMultipliers') {
      key = 'History_Description_NumericAction_SetToAmount';
    }
  }
  return key;
}
function _getJobArguments(modelInfo, action) {
  return _.map(modelInfo.metadata.argFields, function (argField) {
    return _formatActionValue(modelInfo, action[argField]);
  });
}
function _formatActionValue(modelInfo, value) {
  if (modelInfo.properties[0] === 'LabelAssociation' || modelInfo.properties[0] === 'LabelDisassociation') {
    return value.length;
  }
  if (modelInfo.entity === 'AdGroup' && modelInfo.properties[0] === 'AdGroupAudienceAssociation') {
    return value.length;
  }
  if ((modelInfo.entity === 'Campaign' || modelInfo.entity === 'AdGroup') && modelInfo.properties[0] === 'AudienceAssociation') {
    return value.length;
  }
  if (_.contains(['Hotel', 'HotelGroup'], modelInfo.entity)) {
    var jsonValue = JSON.parse(value);
    if (modelInfo.properties[0] === 'Bid') {
      return bidUtils.getText(jsonValue, i18n.getString('BulkEdit_HotelCenter_UseParent'));
    } else if (modelInfo.properties[0] === 'BidMultipliers') {
      return bidMultiplierUtils.getMultipliersText(jsonValue, false, i18n.getString('BulkEdit_HotelCenter_UseParent'));
    }
  }
  if (modelInfo.properties[0] === 'BidStrategyId') {
    return _.result(safeJSON.parseSync(value), 'Name', '');
  }
  if (modelInfo.properties[0] === 'BiddingScheme') {
    return 'BiddingScheme_' + _getBiddingSchemeValue(value);
  }
  if (modelInfo.properties[0] === 'AdScheduleUseSearcherTimeZone') {
    return value === 'true' ? 'AdSchedulingTimeZone_LocationOfPerson' : 'AdSchedulingTimeZone_LocationOfYourAccount';
  }
  if (!modelInfo.isNumeric) {
    return value;
  }
  var action = modelInfo.actions[0] || ({});
  if ((modelInfo.properties[0] === 'PercentCpcBid' || modelInfo.properties[0] === 'CommissionRate') && action.ActionType === 'ChangeByPercent') {
    return _formatNumericValue(modelInfo, value, false, false);
  }
  if ((modelInfo.properties[0] === 'PercentCpcBid' || modelInfo.properties[0] === 'CommissionRate') && action.ActionType === 'ChangeByAmount') {
    return _formatNumericValue(modelInfo, value, false, false) + '(%)';
  }
  return _formatNumericValue(modelInfo, value, modelInfo.isCurrency, modelInfo.isPercent);
}
function _localizeAdditionalArgs(modelInfo) {
  var additionalArgs = [];
  _.each(modelInfo.actions, function (item) {
    var mappedValues = _.map(modelInfo.actions[0] || ({}), function (value, key) {
      return !!value ? i18n.getString('History_Description_Arg_' + key, value, pageContext.AccountCurrencyCode) : null;
    });
    additionalArgs = _.union(additionalArgs, _.filter(mappedValues, function (val) {
      return !!val;
    }));
  });
  return additionalArgs;
}
function _localizeCopyPasteArgs(modelInfo) {
  var additionalArgs = [];
  _.each(modelInfo.actions, function (action) {
    if (action.Property && copyPasteDescriptions.args[action.Property]) {
      additionalArgs.push(i18n.getString(copyPasteDescriptions.args[action.Property]));
    }
  });
  return additionalArgs;
}
function _getCopyPasteSummary(jobModel, jobInfo) {
  return jobInfo.entity && copyPasteDescriptions.actions[jobInfo.entity] ? i18n.getString(copyPasteDescriptions.actions[jobInfo.entity]) : '';
}
function _getJobSummaryCashbackPercent(jobModel, jobInfo) {
  jobInfo.properties = ['CashbackPercent'];
  return _getJobSummary(jobModel, jobInfo);
}
function _getJobSummaryCampaignCashbackMonthlyBudget(jobModel, jobInfo) {
  jobInfo.properties = ['CampaignCashbackMonthlyBudget'];
  return _getJobSummary(jobModel, jobInfo);
}
function _getJobSummaryPercentCpcBid(jobModel, jobInfo) {
  jobInfo.properties = ['PercentCpcBid'];
  return _getJobSummary(jobModel, jobInfo);
}
function _getJobSummaryCommissionRate(jobModel, jobInfo) {
  jobInfo.properties = ['CommissionRate'];
  return _getJobSummary(jobModel, jobInfo);
}
function _getJobSummaryCampaignBudget(jobModel, jobInfo) {
  var selection = jobModel.get('Selection'), isMonthly = selection && selection.QueryString && (decodeURIComponent(selection.QueryString).indexOf('Budget/Type eq \'' + campaignBudgetTypes.monthly + '\'') >= 0 || decodeURIComponent(selection.QueryString).indexOf('Budget/Type eq Enum.BudgetType\'' + campaignBudgetTypes.monthly + '\'') >= 0);
  jobInfo.properties = isMonthly ? ['MonthlyBudget'] : ['DailyBudget'];
  return _getJobSummary(jobModel, jobInfo);
}
function _getJobSelection(jobModel, modelInfo) {
  var filter = filterSerializer.fromDescription(jobModel.get('Description')), sortedFilter = splitFilter(filter && filter.FilterExpressions || []), quickFilter = sortedFilter.quickFilter, expressions = sortedFilter.expressions;
  if (filter && filter.idBased) {
    return {
      scope: _getIdBasedScopeString(filter, modelInfo),
      idBased: true
    };
  }
  if (!filter || expressions.length == 0) {
    return {
      scope: _getScopeString(jobModel, modelInfo, quickFilter)
    };
  }
  return {
    scope: _getScopeString(jobModel, modelInfo, quickFilter),
    filter: _getFilterString(expressions)
  };
}
function _getCopyPasteSelection(jobModel, modelInfo) {
  var pasted, filter;
  var copied = pasted = '';
  var selection = _getJobSelection(jobModel, modelInfo);
  if (selection.idBased) {
    filter = filterSerializer.fromDescription(jobModel.get('Description'));
    copied = filter.idsCount > 1 ? i18n.getString(copyPasteDescriptions.idBasedSelection[modelInfo.entity].Plural, filter.idsCount) : i18n.getString(copyPasteDescriptions.idBasedSelection[modelInfo.entity].Singular, filter.idsCount);
  } else {
    copied = i18n.getString(copyPasteDescriptions.filteredSelection[modelInfo.entity]);
  }
  var ids = 0;
  _.each(modelInfo.actions, function (action) {
    _.each(modelInfo.metadata.argFields, function (argField) {
      if (action[argField] && _.isArray(action[argField])) {
        ids += action[argField].length;
      }
    });
  });
  if (modelInfo.entity === 'AdGroup' || modelInfo.entity === 'AssetGroup') {
    pasted = ids > 1 ? i18n.getString('History_Selection_Paste_NCampaigns', ids) : i18n.getString('History_Selection_Paste_OneCampaign', ids);
  } else if (modelInfo.entity !== 'Campaign') {
    pasted = ids > 1 ? i18n.getString('History_Selection_Paste_NAdGroups', ids) : i18n.getString('History_Selection_Paste_OneAdGroup', ids);
  }
  return _.extend(selection, {
    header: copied,
    footer: pasted
  });
}
function _bidAdjustmentJobSelectionFunction(jobModel, modelInfo) {
  if (!_isDemographicsJobModel(jobModel)) {
    return _getJobSelection(jobModel, modelInfo);
  }
  var filter = filterSerializer.fromDescription(jobModel.get('Description'));
  var sortedFilter = splitFilter(filter && filter.FilterExpressions || []);
  return {
    scope: _getScopeString(jobModel, modelInfo, sortedFilter.quickFilter, sortedFilter.dataSourceFilter),
    filter: _getFilterString(sortedFilter.expressions)
  };
}
function _statusSummaryFunction(jobModel, modelInfo) {
  if (!_isDemographicsJobModel(jobModel)) {
    return _getJobSummary(jobModel, modelInfo);
  }
  return _getDemographicsJobSummary(jobModel, modelInfo);
}
function _bidAdjustmentSummaryFunction(jobModel, modelInfo) {
  if (!_isDemographicsJobModel(jobModel)) {
    return _getJobSummary(jobModel, modelInfo);
  }
  return _getDemographicsJobSummary(jobModel, modelInfo);
}
function _getDemographicsJobSummary(jobModel, modelInfo) {
  var filter = filterSerializer.fromDescription(jobModel.get('Description'));
  var sortedFilter = splitFilter(filter && filter.FilterExpressions || []);
  var criterionType = sortedFilter.dataSourceFilter.criterionType.Values[0];
  var entityName = i18n.getString('EntityName_' + modelInfo.entity + '_' + criterionType);
  var jobSummary = '';
  _.each(modelInfo.actions, function (item, index) {
    var singleLineSummary = '';
    var property = modelInfo.properties[index];
    var propertyName = i18n.getString('Property_' + property);
    var i18nActionBasedKey = _geti18nActionBasedKey(modelInfo, index);
    var i18nValueBasedKey = _geti18nValueBasedKey(modelInfo, index);
    var args = _getJobArguments(modelInfo, item);
    var i18nActionBasedArgs = [i18nActionBasedKey, entityName, propertyName].concat(args);
    var i18nValueBasedArgs = [i18nValueBasedKey, entityName, propertyName].concat(args);
    var valueBased = i18n.getString.apply(i18n, i18nValueBasedArgs);
    var actionBased = i18n.getString.apply(i18n, i18nActionBasedArgs);
    singleLineSummary += valueBased || actionBased;
    singleLineSummary = escapeHelper.escape(singleLineSummary);
    jobSummary = index > 0 ? jobSummary.concat('<br/>') : jobSummary;
    jobSummary = jobSummary.concat(singleLineSummary);
  });
  return jobSummary;
}
function _isDemographicsJobModel(jobModel) {
  var filter = filterSerializer.fromDescription(jobModel.get('Description'));
  var sortedFilter = splitFilter(filter && filter.FilterExpressions || []);
  return sortedFilter.dataSourceFilter && sortedFilter.dataSourceFilter.criterionType;
}
function getJobSelection(jobModel) {
  var modelInfo = _getJobModelInfo(jobModel);
  return modelInfo.metadata.jobSelectionFunction ? modelInfo.metadata.jobSelectionFunction(jobModel, modelInfo) : _getJobSelection(jobModel, modelInfo);
}
function getRuleSelection(jobModel, numberOfDigits) {
  var filter = filterSerializer.fromRuleDescription(jobModel.get('Description')), sortedFilter = splitFilter(filter && filter.FilterExpressions || []), quickFilter = sortedFilter.quickFilter, expressions = sortedFilter.expressions, modelInfo = _getJobModelInfo(jobModel);
  if (filter && filter.idBased) {
    var qfilter = _.find(_.values(quickFilter), function (filter) {
      return !_.isUndefined(filter);
    });
    if (qfilter) {
      expressions.splice(0, 1, qfilter);
    } else {
      expressions.splice(0, 1);
    }
    return {
      filter: expressions.length > 0 ? _getFilterString(expressions, numberOfDigits) : null,
      idBased: true
    };
  }
  if (!filter || expressions.length == 0) {
    return {
      scope: _getRuleScope(jobModel, modelInfo, quickFilter)
    };
  }
  return {
    scope: _getRuleScope(jobModel, modelInfo, quickFilter),
    filter: _getFilterString(expressions, numberOfDigits)
  };
}
function _getRuleScope(jobModel, modelInfo, quickFilter) {
  var selection = jobModel.get('Selection'), result = selection && selection.CampaignId ? i18n.getString('RulesManagementGrid_SelectedCampaign') : quickFilter && !!quickFilter.enabledCampaigns ? i18n.getString('History_Selection_AllEnabledCampaigns') : i18n.getString('History_Selection_AllCampaigns');
  if (modelInfo.entity == 'Campaign') {
    return result;
  }
  result += ' > ' + (selection && selection.AdGroupId ? i18n.getString('RulesManagementGrid_SelectedAdGroup') : quickFilter && !!quickFilter.enabledAdGroups ? i18n.getString('History_Selection_AllEnabledAdGroups') : i18n.getString('History_Selection_AllAdGroups'));
  if (modelInfo.entity == 'AdGroup') {
    return result;
  }
  if (modelInfo.entity == 'Keyword') {
    result += ' > ' + (quickFilter && !!quickFilter.enabledKeywords ? i18n.getString('History_Selection_AllEnabledKeywords') : i18n.getString('History_Selection_AllKeywords'));
  } else if (modelInfo.entity == 'Ads') {
    result += ' > ' + (quickFilter && !!quickFilter.enabledAds ? i18n.getString('History_Selection_AllEnabledAds') : i18n.getString('History_Selection_AllAds'));
  } else if (modelInfo.entity == 'DsaTarget') {
    result += ' > ' + (quickFilter && !!quickFilter.enabledAds ? i18n.getString('BulkEdit_History_Selection_AllEnabledDsatargets') : i18n.getString('BulkEdit_History_Selection_AllDsatargets'));
  }
  return result;
}
function _getScopeString(jobModel, modelInfo, quickFilter, dataSourceFilter) {
  var campaign = jobModel.get('Campaign'), adgroup = jobModel.get('AdGroup'), campaignsLabel = campaign ? campaign.Name : quickFilter && !!quickFilter.enabledCampaigns ? i18n.getString('History_Selection_AllEnabledCampaigns') : i18n.getString('History_Selection_AllCampaigns'), result = campaignsLabel;
  if (modelInfo.entity == 'Campaign' || modelInfo.entity == 'CampaignCriterion' || modelInfo.entity == 'NegativeCampaignCriterion') {
    return result;
  }
  result += ' > ' + (adgroup ? adgroup.Name : quickFilter && !!quickFilter.enabledAdGroups ? i18n.getString('History_Selection_AllEnabledAdGroups') : i18n.getString('History_Selection_AllAdGroups'));
  switch (modelInfo.entity) {
    case 'AdGroup':
      return result;
    case 'Keyword':
      result += ' > ' + (quickFilter && !!quickFilter.enabledKeywords ? i18n.getString('History_Selection_AllEnabledKeywords') : i18n.getString('History_Selection_AllKeywords'));
      break;
    case 'Ad':
      result += ' > ' + (quickFilter && !!quickFilter.enabledAds ? i18n.getString('History_Selection_AllEnabledAds') : i18n.getString('History_Selection_AllAds'));
      break;
    case 'AdGroupAudienceAssociation':
      result += ' > ' + i18n.getString('History_Selection_AllAdGroupAudienceAssociation');
      break;
    case 'AudienceAssociation':
      result += ' > ' + i18n.getString('History_Selection_AllAudienceAssociation');
      break;
    case 'DsaTarget':
      result += ' > ' + i18n.getString('BulkEdit_History_Selection_AllDsatargets');
      break;
    case 'PerformanceTarget':
      result = i18n.getString('BulkEdit_History_Selection_AllPerformancetargets');
      break;
  }
  return result;
}
function _getIdBasedScopeString(filter, modelInfo) {
  return i18n.getString('History_Selection_IdBased_' + modelInfo.entity, filter.idsCount);
}
function _getFilterString(filterExpressions, numberOfDigits) {
  if (filterExpressions.length == 0) {
    return '';
  }
  var result = i18n.getString('Filter') + ': ';
  _.each(filterExpressions, function (expr) {
    if (expr.SelectedColumn === 'DeliveryStatus') {
      expr.Values = _.without(expr.Values, deliveryStatus['InlineOpportunity'].toString());
    }
    if (expr.SelectedColumn === 'AdType' && pageContext.Permissions.IsMultiMediaAdsEnabled) {
      var index = expr.Values.indexOf('4096');
      if (index >= 0) {
        expr.Values[index] = '2048';
      }
      index = expr.Values.indexOf('Responsive');
      if (index >= 0) {
        expr.Values[index] = '2048';
      }
    }
    _.extend(expr, {
      columnLocalized: _localizeColumnName(expr),
      operatorLocalized: _localizeOperator(expr),
      valuesLocalized: _localizeValues(expr, numberOfDigits).join(' ' + i18n.getString('Filter_Ampersand') + ' ')
    });
  });
  result = result + _.map(filterExpressions, function (expr) {
    if (expr.SelectedColumn === 'Labels') {
      return i18n.getString('History_Selection_SelectedLabels');
    }
    return expr.columnLocalized + ' ' + expr.operatorLocalized + ' ' + expr.valuesLocalized;
  }).join(', ');
  return result;
}
function _localizeColumnName(expression) {
  if (expression.SelectedColumn.startsWith('CustomColumn')) {
    var customColumnId = expression.SelectedColumn.split('CustomColumn')[1];
    var customColumnService = new customColumnServiceWrapper.CustomColumnServiceWrapper({
      name: customColumnUtils.getCustomColumnPreferenceName(),
      CustomColumns: customColumnPreference.getCustomColumnPreferenceStore()
    });
    var customColumnData = customColumnService.getAll();
    var customColumnInfo = _.find(customColumnData, function (customColumn) {
      return customColumn.id === customColumnId;
    });
    if (customColumnInfo) {
      return customColumnInfo.name;
    } else {
      return i18n.getString('ColumnName_DeletedCustomColumn');
    }
  }
  return i18n.getString('FilterLocalization_DataAttribute_' + expression.SelectedColumn);
}
function _localizeOperator(expression) {
  return i18n.getString('FilterLocalization_FilterOperator_' + expression.SelectedOperator);
}
function _localizeValues(expression, numberOfDigits) {
  var valuesToUse = _.isEmpty(expression.SelectedNames) ? expression.Values : expression.SelectedNames;
  return _.map(valuesToUse, function (value) {
    if (_.contains(['CampaignCashbackScope', 'AdGroupCashbackScope', 'Coupon'], expression.SelectedColumn)) {
      var scopeValue;
      if (value == null) {
        scopeValue = 'None';
      } else {
        scopeValue = _.result(value.split('\''), '1');
      }
      var i18nKey = 'ColumnField_' + expression.SelectedColumn + '_' + scopeValue;
      return i18n.getString(i18nKey);
    }
    if (expression.SelectedColumn === 'DisplayBiddingStrategyType' && !pageContext.Permissions.dynamic.XandrVideoCampaigns) {
      if (value === '12') {
        return i18n.getString('BidStrategy_ManualCpm');
      } else if (value === '11') {
        return i18n.getString('BidStrategy_ManualCpv');
      }
    }
    if (expression.SelectedOperator == 'EnumSelection') {
      return i18n.getString('FilterLocalization_' + expression.SelectedColumn + '_' + value);
    }
    if (_.contains(['CampaignLanguages', 'Languages'], expression.SelectedColumn)) {
      return i18n.getString('Language_' + value);
    }
    if (_.contains(booleanFields, expression.SelectedColumn)) {
      return i18n.getString('FilterLocalization_BooleanFilter_' + value);
    }
    if (expression.SelectedColumn === 'HasAuctionInsight') {
      return i18n.getString('FilterLocalization_BooleanFilter_Available_' + value);
    }
    if (expression.SelectedColumn === 'AvailableInsightTypeIds') {
      return i18n.getString('Schema_Enum_FluctuationType_' + value);
    }
    if (!expression.SelectedColumn.match('Id$') && _.isNumber(value)) {
      return decimalFormat.fromFloatToString(value, numberOfDigits);
    }
    if (expression.SelectedColumn === 'AdGroupType') {
      if (typeof value === 'string' && value.search('SearchStandard') !== -1) {
        return i18n.getString('AdGroupType_SearchStandard');
      } else if (typeof value === 'string' && value.search('SearchDynamic') !== -1) {
        return i18n.getString('AdGroupType_SearchDynamic');
      }
      return '-';
    }
    return value;
  });
}
function mapEntityErrors(entityResult) {
  var apiErrorMessages = _.isArray(entityResult.Errors) ? _.map(entityResult.Errors, function (error) {
    return errorMapper.mapCampaignApiErrorCodeShort(error) || errorMapper.mapCampaignApiErrorCode(error);
  }) : [], editorialErrors = _.isArray(entityResult.EditorialErrors) ? errorMapper.mapEditorialErrors(entityResult.EditorialErrors, true) : [], editorialErrorMessages = _.map(editorialErrors, function (error) {
    return i18n.getString('HistoryJobDetails_EditorialError', error.countryName, error.message);
  });
  return apiErrorMessages.concat(editorialErrorMessages);
}
;
function formatRSAString(value, property) {
  var rsaString = '';
  if (property === 'AdHeadlines') {
    rsaString = RSAHelper.getTitlePreviewFromJson(value);
  } else if (property === 'AdDescriptions') {
    rsaString = RSAHelper.getDescPreviewFromJson(value);
  }
  return rsaString;
}
function _formatEntityValue(modelInfo, changes, newValue) {
  if (changes.length == 1) {
    var value = newValue ? changes[0].NewValue : changes[0].OriginalValue;
    if (!modelInfo.isNumeric) {
      var formattedValue = i18n.getString('History_Description_' + value);
      if (_.contains(['AdHeadlines', 'AdDescriptions'], changes[0].Property)) {
        value = formatRSAString(value, changes[0].Property);
      }
      return !formattedValue ? escapeHelper.escape(value) : formattedValue;
    }
    return _formatNumericValue(modelInfo, value, true, modelInfo.isPercent);
  } else {
    var formattedValue = '';
    _.each(changes, function (item, index) {
      var propertyMsg = i18n.getString('BulkEdit_Property_' + changes[index].Property) || splitProperty(changes[index].Property);
      var propertyName = ('<br>').concat(propertyMsg).concat(': '), value = newValue ? changes[index].NewValue : changes[index].OriginalValue;
      if (_.contains(['AdHeadlines', 'AdDescriptions'], item.Property)) {
        value = formatRSAString(value, item.Property);
      } else {
        value = escapeHelper.escape(value);
      }
      formattedValue = propertyName ? formattedValue.concat(propertyName).concat(value) : formattedValue.concat(value);
    });
    return formattedValue;
  }
}
function _formatCopyPasteEntityValue(modelInfo, changes, newValue) {
  var entity = {};
  _.each(changes, function (change) {
    var field = copyPasteDescriptions.entityProperties[change.Property];
    if (field) {
      entity[field] = newValue ? change.NewValue : change.OriginalValue;
    }
  });
  return entity;
}
function _formatBiddingSchemeEntityValue(modelInfo, changes, newValue, entityKeys) {
  if (changes.length >= 1) {
    var originalPBS = safeJSON.parseSync(_.result(_.find(entityKeys, {
      Key: 'BidStrategyId'
    }), 'Value')) || ({});
    if (originalPBS.Id && !newValue) {
      return originalPBS.Name;
    } else {
      var value = newValue ? changes[0].NewValue : changes[0].OriginalValue;
      var formattedValue = i18n.getString('History_Description_BiddingScheme_' + _getBiddingSchemeValue(value));
      return formattedValue || escapeHelper.escape(value);
    }
  }
}
function _formatBidStrategyIdEntityValue(modelInfo, changes, isNew, entityKeys) {
  if (changes.length >= 1) {
    var originalValue = safeJSON.parseSync(changes[0].OriginalValue) || ({});
    var newValue = safeJSON.parseSync(changes[0].NewValue) || ({});
    if (!originalValue.Id && !isNew) {
      var originalIBS = _.result(_.find(entityKeys, {
        Key: 'BiddingScheme'
      }), 'Value', '{}');
      var formattedValue = i18n.getString('History_Description_BiddingScheme_' + _getBiddingSchemeValue(originalIBS));
      return formattedValue || escapeHelper.escape(originalIBS);
    } else {
      return isNew ? newValue.Name : originalValue.Name;
    }
  }
}
function _formatBidEntityValue(modelInfo, changes, newValue) {
  var value = newValue ? changes[0].NewValue : changes[0].OriginalValue;
  try {
    value = JSON.parse(value);
    return bidUtils.getText(value, i18n.getString('BulkEdit_HotelCenter_UseParent'));
  } catch (e) {
    return '';
  }
}
function getHotelCenterBidAmountAddonText(modelInfo) {
  var action = modelInfo.actions[0] || ({});
  return _.result({
    'ChangeByAmount': pageContext.AccountCurrencyCode,
    'ChangeByPercent': ''
  }, action.ActionType);
}
function _formatBidAmountEntityValue(modelInfo, changes, newValue) {
  if (_.contains(['Hotel', 'HotelGroup'], modelInfo.entity)) {
    var value = newValue ? changes[0].NewValue : changes[0].OriginalValue;
    var formattedNumber = decimalFormat.fromFloatToString(value);
    var addonText = getHotelCenterBidAmountAddonText(modelInfo);
    return [formattedNumber, addonText].join(' ');
  } else {
    return _formatEntityValue(modelInfo, changes, newValue);
  }
}
function _localizePercentAdditionalArgs(modelInfo) {
  var action = modelInfo.actions[0] || ({});
  if (action.Limit) {
    var limitText = i18n.getString('History_Description_Arg_Limit_NoSpace', action.Limit, '%');
    return [limitText];
  }
  return [];
}
function _localizeBidAmountAdditionalArgs(modelInfo) {
  if (_.contains(['Hotel', 'HotelGroup'], modelInfo.entity)) {
    var action = modelInfo.actions[0] || ({});
    if (action.Limit) {
      var addonText = getHotelCenterBidAmountAddonText(modelInfo);
      var limitText = i18n.getString('History_Description_Arg_Limit', action.Limit, addonText);
      return [limitText];
    }
    return [];
  } else {
    return _localizeAdditionalArgs(modelInfo);
  }
}
function _formatBidMultipliersEntityValue(modelInfo, changes, newValue) {
  var value = newValue ? changes[0].NewValue : changes[0].OriginalValue;
  try {
    value = JSON.parse(value);
    return bidMultiplierUtils.getMultipliersDetailText(value, i18n.getString('BulkEdit_HotelCenter_UseParent'));
  } catch (e) {
    return '';
  }
}
function _getBiddingSchemeValue(value) {
  var typeReg = /.*"Type":([0-9]+).*$/;
  var matches = value.match(typeReg);
  if (matches && matches[1]) {
    return matches[1];
  } else {
    return '';
  }
}
function formatEntityValue(jobModel, changes, newValue, entityKeys) {
  var modelInfo = _getJobModelInfo(jobModel);
  return modelInfo.metadata.formatEntityValueFunction ? modelInfo.metadata.formatEntityValueFunction(modelInfo, changes, newValue, entityKeys) : _formatEntityValue(modelInfo, changes, newValue);
}
function _formatNumericValue(modelInfo, value, asCurrency, isPercent) {
  var coverNegativeNumber = modelInfo.entity && (modelInfo.entity === 'AdGroupAudienceAssociation' || modelInfo.entity === 'AudienceAssociation' || modelInfo.entity === 'CampaignCriterion' || modelInfo.entity === 'AdGroupCriterion') ? modelInfo.properties && modelInfo.properties.length >= 1 && (modelInfo.properties[0] === 'AudienceCriterion/BidMultiplier' || modelInfo.properties[0] === 'BidAdjustment') ? true : false : false;
  var formattedNumber = decimalFormat.fromFloatToString(coverNegativeNumber ? value : Math.abs(value)), currencySuffix = asCurrency ? ' ' + pageContext.AccountCurrencyCode : '';
  var suffix = isPercent ? '%' : currencySuffix;
  return formattedNumber + suffix;
}
function splitFilter(filterExpressions) {
  var quickFilter = _.chain(quickFilters).keys().map(function (qfKey) {
    var matchingExpression = _.find(filterExpressions, function (expr) {
      return _.isEqual(_.pick(expr, 'SelectedColumn', 'SelectedOperator', 'Values'), quickFilters[qfKey]);
    });
    return [qfKey, matchingExpression];
  }).object().value();
  var dataSourceFilter = _.chain(dataSourceFilters).keys().map(function (qfKey) {
    var matchingExpression = _.find(filterExpressions, function (expr) {
      return _.isEqual(_.pick(expr, 'SelectedColumn', 'SelectedOperator'), _.pick(dataSourceFilters[qfKey], 'SelectedColumn', 'SelectedOperator'));
    });
    return [qfKey, matchingExpression];
  }).object().value();
  return {
    quickFilter: quickFilter,
    dataSourceFilter: dataSourceFilter,
    expressions: _.difference(filterExpressions, _.values(quickFilter), _.values(dataSourceFilter))
  };
}
function getJobDetails(jobModel) {
  var modelInfo = _getJobModelInfo(jobModel);
  return modelInfo.metadata.historyJobDetails ? modelInfo.metadata.historyJobDetails : 'DefaultHistoryJobDetails';
}
export default {
  getJobDescription: getJobDescription,
  getJobSelection: getJobSelection,
  mapEntityErrors: mapEntityErrors,
  formatEntityValue: formatEntityValue,
  getRuleSelection: getRuleSelection,
  splitFilter: splitFilter,
  getJobDetails: getJobDetails
};

